module.exports = __webpack_public_path__ + "img/zf-k.89d82c39.png";